import { Box, Grid } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BackButton, CardBox, CustomButton } from "../../../../components";
import { errorAlert } from "../../../../helpers/alerts";
import { EditOutlined } from "@mui/icons-material";
import {
  getBagOperatorService,
  getBagRegionService,
  getBagSegmentService,
  getBagDenominationsService,
} from "../../../../services/client/bagService";
import {
  setOperators,
  setCurrentOperator,
  setRegions,
  setCurrentRegion,
  setSegments,
  setCurrentSegment,
  setDenominations,
} from "../../../../redux/slices/client/bagSlice";
import { setTitle } from "../../../../redux/slices/uiSlice";
import { validatePermission } from "helpers/authentication";

const BagTAEScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { hoster } = useSelector(store => store.session);
  const { currentCommerce } = useSelector((store) => store.commerces);
  const currentBag = currentCommerce.bags.find(bag => bag.type === 'TAE');
  const {
    operators,
    regions,
    segments,
    denominations,
    currentOperator,
    currentRegion,
    currentSegment,
  } = useSelector((store) => store.bags);
  const bottom = useRef(null)
  const [loadingOperator, setLoadingOperator] = useState(false)
  const [loadingRegions, setLoadingRegions] = useState(false)
  const [loadingSegments, setLoadingSegments] = useState(false)
  const [loadingDenominations, setLoadingDenominations] = useState(false)

  useEffect(() => {
    dispatch(setTitle('Productos de la bolsa'));
    setLoadingOperator(true)
    getBagOperatorService(currentBag._id)
      .then((response) => dispatch(setOperators(response)))
      .catch((error) => errorAlert(error))
      .finally(() => setLoadingOperator(false));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (currentOperator) {
      if (currentOperator.regions) {
        setLoadingRegions(true)
        getBagRegionService(
          currentBag._id,
          currentOperator._id
        ).then((result) => dispatch(setRegions(result)))
          .catch((error) => errorAlert(error))
          .finally(() => {
            setLoadingRegions(false)
            bottom.current.scrollIntoView({ behavior: 'smooth' })
          });
      } else {
        setLoadingSegments(true)
        getBagSegmentService(
          currentBag._id,
          currentOperator._id
        ).then((result) => dispatch(setSegments(result)))
          .catch((error) => errorAlert(error))
          .finally(() => {
            setLoadingSegments(false)
            bottom.current.scrollIntoView({ behavior: 'smooth' })
          });
      }
    }
    // eslint-disable-next-line
  }, [currentOperator]);

  useEffect(() => {
    if (currentRegion) {
      setLoadingSegments(true)
      getBagSegmentService(
        currentBag._id,
        currentOperator._id,
        currentRegion._id
      ).then((result) => dispatch(setSegments(result)))
        .catch((error) => errorAlert(error))
        .finally(() => {
          setLoadingSegments(false)
          bottom.current.scrollIntoView({ behavior: 'smooth' });
        });
    }
    // eslint-disable-next-line
  }, [currentRegion]);

  useEffect(() => {
    if (currentSegment) {
      setLoadingDenominations(true)
      getBagDenominationsService(
        currentBag._id,
        currentOperator._id,
        currentRegion?._id,
        currentSegment._id
      ).then((result) => dispatch(setDenominations(result)))
        .catch((error) => errorAlert(error))
        .finally(() => {
          setLoadingDenominations(false)
          bottom.current.scrollIntoView({ behavior: 'smooth' });
        });
    }
    // eslint-disable-next-line
  }, [currentSegment]);

  const handlerClickOperator = (bagOperator) => {
    if (bagOperator._id !== currentOperator?._id) {
      batch(() => {
        dispatch(setCurrentOperator(bagOperator));
        dispatch(setCurrentRegion());
        dispatch(setCurrentSegment());
      });
    }
  };
  const handlerClickRegion = (bagRegion) => {
    if (bagRegion._id !== currentRegion?._id) {
      batch(() => {
        dispatch(setCurrentRegion(bagRegion));
        dispatch(setCurrentSegment());
      });
    }
  };
  const handlerClickSegment = (bagSegment) => {
    if (bagSegment._id !== currentSegment?.id)
      dispatch(setCurrentSegment(bagSegment));
  };

  return (
    <Box mt={2}>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <div>
          <BackButton click={() => {
            dispatch(setCurrentOperator(null));
            dispatch(setCurrentRegion(null));
            dispatch(setCurrentSegment(null));
            navigate('/cliente/comercios')
          }} />
        </div>
        <div className="container-title">
          <div className="commerce">{currentCommerce.username} </div>
          <div className="bag">{currentBag.username} </div>
        </div>
        <div>
          {
            hoster?.id != currentCommerce._id && <CustomButton
              dark={true}
              icon={<EditOutlined />}
              name={'Editar'}
              click={() => navigate("operadoras")}
            />
          }
        </div>
      </Grid>
      <Box mt={2}>
        <CardBox
          name={"Operadoras"}
          loading={loadingOperator}
          values={operators.filter((item) => item.commerce)}
          handleSelect={handlerClickOperator}
          isSelect={currentOperator?._id}
          buttons={[
            (validatePermission('comercios', 'comisiones', ['ver']) && currentBag.earnings === 'COMPRA') && {
              type: "custom",
              element: <span>{`Comisión General: ${currentBag.purchaseCommission || '0'}%`}</span>,
            },
          ]}
          formatter={(item) => {
            const { commission } = item.commerce;
            return {
              ...item,
              id: item._id,
              image: `/v3/file/${item.fd}/`,
              commission,
            };
          }}
          element={({ commission }) => (
            currentBag.earnings === 'VENTA' &&
            <div className="commission">Comisión: {commission}%</div>
          )}
        />
      </Box>
      <div>
        {
          ((currentOperator && currentOperator?.regions) || loadingRegions) && (
            <CardBox
              name={"Regiones"}
              loading={loadingRegions}
              values={regions.filter((item) => item.commerce)}
              handleSelect={handlerClickRegion}
              isSelect={currentRegion?._id}
              buttons={[
                // validatePermission('proveedores', 'productos', ['agregar', 'editar', 'eliminar']) &&
                hoster?.id != currentCommerce._id && {
                  icon: <EditOutlined />,
                  key: "regions",
                  name: "Editar",
                  click: () => navigate("regiones"),
                },
              ]}
              formatter={(item) => {
                const { commission } = item.commerce;
                return {
                  ...item,
                  id: item._id,
                  name: item.nombre,
                  commission,
                };
              }}
              element={({ commission }) => (
                currentBag.earnings === 'VENTA' &&
                <div className="commission">Comisión: {commission}%</div>
              )}
            />
          )}
      </div>
      <div>
        {((currentOperator && !currentOperator.regions) || currentRegion || loadingSegments) && (
          <CardBox
            name={"Segmentos"}
            loading={loadingSegments}
            values={segments.filter((item) => item.commerce)}
            handleSelect={handlerClickSegment}
            isSelect={currentSegment?._id}
            buttons={[
              // validatePermission('proveedores', 'productos', ['agregar', 'editar', 'eliminar']) &&
              hoster?.id != currentCommerce._id && {
                icon: <EditOutlined />,
                key: "segments",
                name: "Editar",
                click: () => navigate("segmentos"),
              },
            ]}
            formatter={(item) => {
              const { commission } = item.commerce;
              return {
                ...item,
                id: item._id,
                image: `/v3/file/${item.fd}/`,
                commission,
              };
            }}
            element={({ commission }) => (
              currentBag.earnings === 'VENTA' &&
              <div className="commission">Comisión: {commission}%</div>
            )}
          />
        )}
      </div>
      <div>
        {
          ((currentSegment && !denominations.error) || loadingDenominations) && (
            <CardBox
              name={"Denominaciones"}
              loading={loadingDenominations}
              values={denominations.filter((item) => item.commerce).sort((a, b) => a.denomination - b.denomination)}
              buttons={[
                //validatePermission('proveedores', 'productos', ['agregar', 'editar', 'eliminar']) &&
                hoster?.id != currentCommerce._id && {
                  icon: <EditOutlined />,
                  key: "denominations",
                  name: "Editar",
                  click: () => navigate("denominaciones"),
                },
              ]}
              formatter={(item) => {
                const { commission } = item.commerce;
                return {
                  ...item,
                  id: item._id,
                  name: item.denomination,
                  commission,
                };
              }}
              element={({ commission }) => (
                currentBag.earnings === 'VENTA' &&
                <div style={{
                  textAlign: 'center',
                }}>Comisión: {commission}%</div>
              )}
            />
          )}
      </div>
      <div ref={bottom} />
    </Box>
  );
};

export default BagTAEScreen;
